<template>
  <!-- 分类导航 -->
  <div class="slideshowBox">
    <div class="navBox">
      <div class="logo" @click="refresh()">
        <div style="height: 47px">
          <img src="./images/logo@2x.png" alt="" />
        </div>
      </div>
      <div class="dq" @click.stop="xzsf()">
        <i class="el-icon-location-outline" style="font-size: 16px; margin-right: 5px; color: #333"></i>
        <div style="font-size: 16px">
          {{ "山东省" }}
        </div>
        <i style="margin-left: 3px" class="el-icon-arrow-down"></i>
      </div>
      <div class="navBar">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" background-color="#fff"
          text-color="#333" active-text-color="#3370FF" @select="handleSelect">
          <!-- 渲染没有子菜单的项目 -->
          <el-menu-item v-for="item in menuList" :key="item.code" :index="item.url" @click="handleMenuClick(item)">
            {{ item.name }}
          </el-menu-item>
          <!-- 渲染带子菜单的项目 -->
          <el-submenu v-for="item in submenuList" :key="item.code" :index="item.code">
            <template #title>{{ item.name }}</template>
            <!-- 子菜单项 -->
            <el-menu-item v-for="subItem in item.customMenus" :key="subItem.menuId" :index="subItem.url"
              @click="handleMenuClick(subItem)">
              {{ subItem.menuName }}
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="userInfo">
        <div style="height: 30px; margin-right: 20px" @click="go()">
          <img src="./images/ktvip.png" alt="" />
        </div>

        <div v-if="userInfoObj.avatar == null" class="avatar" style="
            width: 36px;
            height: 36px;
            background: #e8e8e8;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 8px;
          "></div>
        <div v-else class="avatar" style="
            width: 36px;
            height: 36px;
            background: #e8e8e8;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 8px;
          ">
          <img :src="userInfoObj.avatar" alt="" />
        </div>
        <div class="info" v-if="userInfoObj.nickName == null && userInfoObj.mobile == null">
          <div style="
              vertical-align: middle;
              display: inline-block;
              width: 100px;
              height: 30px;
              border-radius: 10px 10px 10px 10px;
              border: 1px solid #202003 !important;
              font-weight: 400;
              font-size: 16px;
              color: #202003 !important;
              text-align: center;
              line-height: 30px;
              margin-left: 18px;
            " @click="getUserInfo()">
            登录/注册
          </div>
        </div>
        <el-popover v-else placement="bottom" trigger="click">
          <div class="user-menu___OA9iU" v-if="userInfoObj.nickName !== '' &&
        userInfoObj.mobile !== '' &&
        userInfoObj.customerType == 0
        ">
            <div class="user-menu-item___SfQSJ" @click="goPersonalCenter(0)">
              <i class="el-icon-s-custom"></i>
              <span style="margin-left: 10px">账号信息</span>
            </div>
            <!-- <div class="user-menu-item___SfQSJ" style="display: block;">我的成绩</div> -->
            <div class="user-menu-item___SfQSJ" @click="goTab()">
              <i class="el-icon-s-order"></i>
              <span style="margin-left: 10px">我的志愿表</span>
            </div>
            <!-- <div class="user-menu-item___SfQSJ" style="display: block;">我的测评</div> -->
            <div class="user-menu-item___SfQSJ" @click="goPersonalCenter(1)">
              <i class="el-icon-s-grid"></i>
              <span style="margin-left: 10px">我的订单</span>
            </div>
            <div class="user-menu-item___SfQSJ" style="color: #f11717" @click="laouyt()">
              <i class="el-icon-switch-button"></i>
              <span style="margin-left: 10px">退出登录</span>
            </div>
          </div>

          <div class="user-menu___OA9iU" v-else>
            <div class="user-menu-item___SfQSJ" @click="goPersonalCenter(0)">
              <i class="el-icon-s-custom"></i>
              <span style="margin-left: 10px">账号信息</span>
            </div>
            <div class="user-menu-item___SfQSJ" @click="goTab(1)">
              <i class="el-icon-s-marketing"></i>
              <span style="margin-left: 10px">专家志愿表</span>
            </div>
            <!-- <div
              class="user-menu-item___SfQSJ"
              @click="goTab()"
            >
              <i class="el-icon-s-order"></i>
              <span style="margin-left: 10px">我的志愿表</span>
            </div> -->
            <div class="user-menu-item___SfQSJ" @click="goPersonalCenter(1)">
              <i class="el-icon-s-grid"></i>
              <span style="margin-left: 10px">我的订单</span>
            </div>

            <div class="user-menu-item___SfQSJ" style="display: block; color: #f11717" @click="laouyt()">
              <i class="el-icon-switch-button"></i>
              <span style="margin-left: 10px">退出登录</span>
            </div>
          </div>

          <div slot="reference" class="info">
            <div class="name" style="max-width: 200px; overflow: hidden">
              {{
        userInfoObj.nickName !== "" ? userInfoObj.nickName : "新用户"
      }}
              <span style="font-weight: normal; font-size: 12px">
                {{ userInfoObj.customerType == 1 ? `(专家组)` : "" }}</span>
              <i style="margin-left: 3px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import { GetCustomerInfoById } from "@/api/user";
export default {
  name: "TypeNav",
  props: {
    rootMenus: {
      type: Array,
      required: true,
    },
    Info: {
      type: Object,
    },
  },
  computed: {
    // 筛选出带有子菜单的列表
    submenuList() {
      return this.rootMenus.filter(
        (item) => item.customMenus && item.customMenus.length > 0
      );
    },
    // 筛选出没有子菜单的列表
    menuList() {
      return this.rootMenus.filter(
        (item) => !item.customMenus || item.customMenus.length === 0
      );
    },
  },
  data() {
    return {
      activeIndex: "/carrerpostion",
      list: [
        {
          code: "1006",
          name: "首页",
          type: 1,
          url: "http://zy.ycymedu.com/",
          customMenus: [],
        },
        {
          code: "1002",
          name: "查数据",
          type: 1,
          url: "http://zy.ycymedu.com/colleges/search",
          customMenus: [
            {
              menuId: 340169070010437,
              rootId: 1002,
              menuName: "院校库",
              icon: "icon-xuexishuben",
              url: "http://zy.ycymedu.com/colleges/search",
              type: 1,
              sort: 114,
            },
            {
              menuId: 340169332207685,
              rootId: 1002,
              menuName: "专业库",
              icon: "icon-xuexishuben",
              url: "http://zy.ycymedu.com/majors/list",
              type: 1,
              sort: 115,
            },
            {
              menuId: 340169427357765,
              rootId: 1002,
              menuName: "职业库",
              icon: "icon-xuexishuben",
              url: "http://zy.ycymedu.com/careers/list",
              type: 1,
              sort: 116,
            },
          ],
        },
        {
          code: "1004",
          name: "志愿填报",
          type: 1,
          url: "http://zy.ycymedu.com/tzy/choosebatch?type=1",
          customMenus: [
            {
              menuId: 340166511046725,
              rootId: 1004,
              menuName: "智能填报",
              icon: "icon-xuexishuben",
              url: "http://zy.ycymedu.com/tzy/choosebatch?type=1",
              type: 1,
              sort: 107,
            },
            {
              menuId: 340166882791493,
              rootId: 1004,
              menuName: "院校优先",
              icon: "icon-xuexishuben",
              url: "http://zy.ycymedu.com/tzy/choosebatch?type=1",
              type: 1,
              sort: 108,
            },
            {
              menuId: 340166955491397,
              rootId: 1004,
              menuName: "专业优先",
              icon: "icon-xuexishuben",
              url: "http://zy.ycymedu.com/tzy/choosebatch?type=2",
              type: 1,
              sort: 109,
            },
          ],
        },
        {
          code: "1001",
          name: "学职生涯",
          url: "carrerpostion",
          customMenus: [
            {
              menuId: 339907260608581,
              rootId: 1001,
              menuName: "学职定位",
              icon: "icon-dingweifangxiang",
              url: "/carrerpostion",
              type: 0,
              sort: 100,
            },
            {
              menuId: 339907931545669,
              rootId: 1001,
              menuName: "学习状态",
              icon: "icon-zhuangtai",
              url: "/studystatus",
              type: 0,
              sort: 101,
            },
            {
              menuId: 339908117110853,
              rootId: 1001,
              menuName: "心理测评",
              icon: "icon-zaixianceping",
              url: "/psychology",
              type: 0,
              sort: 102,
            },
            {
              menuId: 339908204716101,
              rootId: 1001,
              menuName: "我的报告",
              icon: "icon-report-fill",
              url: "/report",
              type: 0,
              sort: 103,
            },
          ],
        },
        {
          code: "1005",
          name: "升学规划",
          url: "entrancepath",
          customMenus: [
            {
              menuId: 340167996190789,
              rootId: 1005,
              menuName: "升学路径",
              icon: "icon-yonghulujing",
              url: "/entrancepath",
              type: 0,
              sort: 103,
            },
            {
              menuId: 340168240468037,
              rootId: 1005,
              menuName: "特殊招生",
              icon: "icon-xuesheng",
              url: "/specialentrance",
              type: 0,
              sort: 111,
            },
            {
              menuId: 339908455198789,
              rootId: 1005,
              menuName: "出国留学",
              icon: "icon-chuguojingjinxiu",
              url: "/studyabroad",
              type: 0,
              sort: 112,
            },
          ],
        },
        {
          code: "1006",
          name: "专家咨询",
          url: "expertteam",
          customMenus: [
            {
              menuId: 340168509984837,
              rootId: 1006,
              menuName: "专家团队",
              icon: "icon-xuexishuben",
              url: "/expertteam",
              type: 0,
              sort: 113,
            },
          ],
        },
      ],
      userInfoObj: ''
    };
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    go() {
      window.open('https://dev.zytb.ycymedu.com/Home/ClubCard', "_blank");
    },
    async getUserInfo() {
      const res = await GetCustomerInfoById();
      this.userInfoObj = res.result;
    },
    goPersonalCenter(id) {
      if (id == 0) {
        window.open('https://dev.zytb.ycymedu.com/Home/PersonalCenter?IsShow=0', "_blank");
      }
      if (id == 1) {
        window.open('https://dev.zytb.ycymedu.com/Home/PersonalCenter?IsShow=1', "_blank");
      }
    },
    goTab() {
      window.open('https://dev.zytb.ycymedu.com/Home/zyTable', "_blank");
    },
    // 退出登录
    laouyt() {
      this.$confirm("确定退出登录？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("user/removeStudentInfo"); // 调用 `user` 模块下的 `logout` action
          this.$store.dispatch("user/logout"); // 调用 `user` 模块下的 `logout` action
          this.$router.push("/Home/FirstPage");
          location.reload(); // 确保清除缓存的状态
          // window.location.href = process.env.VUE_APP_SSO_URL;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出",
          });
        });
    },
    handleMenuClick(menuItem) {
      if (menuItem.type === 1) {
        // 外部链接跳转
        window.open(menuItem.url, "_blank");
      } else if (menuItem.type === 0) {
        // 本地页面跳转并附带 menuId 参数
        this.$router.push({
          path: menuItem.url,
          query: { menuId: menuItem.menuId },
        });
      }
    },
    handleSelect(index) {
      this.activeIndex = index;
    },
    out() {
      this.$store.dispatch("user/logout");
      sessionStorage.removeItem("setTenantId");
      sessionStorage.removeItem("studentInfo");
      sessionStorage.removeItem("isactive");
      sessionStorage.removeItem("active");
      this.$router.push("/Login");
      this.$message({
        type: "success",
        message: "退出成功!",
      });
    },
    // goUrl(index, routeUrl) {
    //   if (index === 1 || index === 2 || index === 5) {
    //     console.log(index);
    //   } else {
    //     console.log("index", index);
    //     sessionStorage.setItem("isactive", index);
    //   }
    //   if (index === 0) {
    //     this.isactive = index;
    //     this.$emit("switchover", index);
    //   }
    //   if (index === 1) {
    //     window.open(routeUrl, "_blank");
    //   }
    //   if (index === 2) {
    //     window.open(routeUrl, "_blank");
    //   }
    //   if (index === 3) {
    //     this.isactive = index;
    //     this.$emit("switchover", index);
    //   }
    //   if (index === 4) {
    //     this.isactive = index;
    //     this.$emit("switchover", index);
    //   }
    //   if (index === 5) {
    //     window.open(routeUrl, "_blank");
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.el-menu--horizontal>.el-menu-item {
  border-bottom: none !important;
}

::v-deep .el-dialog {
  border-radius: 18px;
}

::v-deep .el-submenu__icon-arrow {
  font-size: 16px;
  font-weight: bold;
}

.user-menu___OA9iU {
  .user-menu-item___SfQSJ {
    font-size: 16px;
    font-weight: 400;
    color: #333;
    line-height: 28px;
    margin-bottom: 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .user-menu-line___mwoOJ {
    width: 190px;
    height: 1px;
    border-bottom: 1px solid #efefef;
  }

  .logout___m8_S5 {
    font-size: 16px;
    font-weight: 400;
    color: #272727;
    line-height: 28px;
    margin-top: 25px;
    text-align: center;
    cursor: pointer;
  }
}

.cityFrame {
  width: 100%;
  height: 100%;

  .home-city {
    margin: 0 auto;
    color: #333;
    background-color: #fff;
    filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=rgba(127, 0, 0, 0), endcolorstr=rgba(127, 0, 0, 0));
    border-radius: 18px;

    h1 {
      font-weight: 500;
      font-size: 24px;
      color: #333;
      text-align: center;
      margin-top: 40px;
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 7px;

      li {
        display: inline-block;
        font-size: 16px;
        border: 1px solid #eee;
        border-radius: 8px;
        width: 10%;
        text-align: center;
        height: 40px;
        line-height: 40px;
        margin-top: 10px;
        background-color: rgb(248, 248, 248);
        color: #333;
        cursor: pointer;
      }

      li:hover {
        color: #409eff !important;
      }

      .city-btn-bg {
        color: #409eff !important;
        border: 1px solid #409eff !important;
      }
    }

    .city-btn {
      background-color: #409eff;
      color: #fff;
      text-align: center;
      line-height: 51px;
      font-size: 18px;
      margin: auto;
      margin-top: 40px;
      border-radius: 12px;
      width: 191px;
      height: 51px;
      opacity: 1;
      cursor: pointer;
    }
  }
}

::v-deep .el-submenu__title:hover {
  background-color: #fff !important;
  color: #187cff !important;
}

::v-deep.el-menu-item:hover {
  color: #187cff !important;
  background-color: #fff !important;
}

::v-deep .el-menu.el-menu--horizontal {
  border-bottom: none;
}

::v-deep .el-menu--horizontal>.el-menu-item.is-active {
  color: #303133;
  font-weight: 600;
  border: none !important;

  .el-submenu__title i {
    color: #187cff !important;
  }
}

::v-deep .el-menu--horizontal>.el-submenu.is-active {
  color: #303133;
  border: none !important;
  font-weight: 600;

  .el-submenu__title i {
    color: #187cff !important;
  }
}

::v-deep .el-menu--horizontal>.el-menu-item {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  background-color: rgb(255, 255, 255) !important;
}

::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title {
  height: 50px;
  line-height: 50px;
  border: none !important;
  font-size: 16px;
}

.dq {
  cursor: pointer;
  position: absolute;
  top: 30%;
  left: 200px;
  text-align: center;
  line-height: 30px;
  padding: 0 5px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid #eee;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

img {
  width: 100%;
  height: 100%;
}

.slideshowBox {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  width: 100%;
  font-family: PingFangSC-Regular, PingFang SC;
  background: #fff;
  height: 75px;
  z-index: 22;

  .navBox {
    position: relative;
    width: 1280px;
    margin: 0 auto;
    background: #fff;
    height: 100%;
  }

  .logo {
    cursor: pointer;
    z-index: 23;
    position: absolute;
    top: 20%;
    left: 0;
    height: 50px;
  }

  .userInfo {
    position: absolute;
    top: 30%;
    right: 0;
    display: flex;
    align-items: center;
    z-index: 222;
    cursor: pointer;

    .info {
      display: flex;
      align-items: center;
      justify-content: center;

      .name {
        font-size: 20px;
        font-weight: 600;
        margin-right: 5px;
      }

      .NoVip {
        width: 25px;
        height: 21px;
      }

      .NoVips {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 88px;
        height: 35px;
        background: #f46a3e;
        border-radius: 5px;
      }
    }
  }

  .navBar .el-submenu.is-active {
    color: #187cff;
    font-weight: bold;
    position: relative;
    /* 为伪元素定位做准备 */
  }

  .navBar .el-submenu.is-active::after {
    content: "";
    /* 使用伪元素生成下划线 */
    position: absolute;
    bottom: 0;
    left: 41%;
    /* 居中对齐 */
    transform: translateX(-50%);
    width: 20px;
    /* 下划线宽度为菜单项宽度的一半 */
    height: 2px;
    background-color: #187cff;
  }

  .navBar .el-menu-item.is-active {
    color: #187cff;
    font-weight: bold;
    position: relative;
    /* 为伪元素定位做准备 */
  }

  .navBar .el-menu-item.is-active::after {
    content: "";
    /* 使用伪元素生成下划线 */
    position: absolute;
    bottom: 0;
    left: 50%;
    /* 居中对齐 */
    transform: translateX(-50%);
    width: 20px;
    /* 下划线宽度为菜单项宽度的一半 */
    height: 2px;
    background-color: #187cff;
  }

  .navBar {
    width: 100%;
    cursor: pointer;
    z-index: 22;
    position: absolute;
    top: 30%;
    transform: translate(-50%, 0);
    left: 50%;
    height: 30px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;

    .nav {
      margin-left: 72px;
    }

    .nav:nth-child(1) {
      margin-left: 82px !important;
    }

    .nav:hover {
      /*  */
      color: #187cff;
    }

    .navActive {
      color: #187cff;
      font-weight: bold;
    }
  }
}
</style>
